__turbopack_export_value__({
  "body-logo-18": "VideoTourSection-module-scss-module__yZHw7W__body-logo-18",
  "body-text-12": "VideoTourSection-module-scss-module__yZHw7W__body-text-12",
  "body-text-14": "VideoTourSection-module-scss-module__yZHw7W__body-text-14",
  "body-text-16": "VideoTourSection-module-scss-module__yZHw7W__body-text-16",
  "body-text-18": "VideoTourSection-module-scss-module__yZHw7W__body-text-18",
  "body-text-20": "VideoTourSection-module-scss-module__yZHw7W__body-text-20",
  "body-text-24": "VideoTourSection-module-scss-module__yZHw7W__body-text-24",
  "body-text-24-2": "VideoTourSection-module-scss-module__yZHw7W__body-text-24-2",
  "body-text-heading-2": "VideoTourSection-module-scss-module__yZHw7W__body-text-heading-2",
  "body-text-heading-3": "VideoTourSection-module-scss-module__yZHw7W__body-text-heading-3",
  "body-text-medium-14": "VideoTourSection-module-scss-module__yZHw7W__body-text-medium-14",
  "body-text-medium-16": "VideoTourSection-module-scss-module__yZHw7W__body-text-medium-16",
  "body-text-medium-18": "VideoTourSection-module-scss-module__yZHw7W__body-text-medium-18",
  "body-text-medium2-18": "VideoTourSection-module-scss-module__yZHw7W__body-text-medium2-18",
  "body-text2-14": "VideoTourSection-module-scss-module__yZHw7W__body-text2-14",
  "body-text2-16": "VideoTourSection-module-scss-module__yZHw7W__body-text2-16",
  "button-primary-text": "VideoTourSection-module-scss-module__yZHw7W__button-primary-text",
  "button-text": "VideoTourSection-module-scss-module__yZHw7W__button-text",
  "button2-text": "VideoTourSection-module-scss-module__yZHw7W__button2-text",
  "card-shadow": "VideoTourSection-module-scss-module__yZHw7W__card-shadow",
  "effect-menu": "VideoTourSection-module-scss-module__yZHw7W__effect-menu",
  "header-1": "VideoTourSection-module-scss-module__yZHw7W__header-1",
  "main-container": "VideoTourSection-module-scss-module__yZHw7W__main-container",
  "main-footer-container": "VideoTourSection-module-scss-module__yZHw7W__main-footer-container",
  "main-header-container": "VideoTourSection-module-scss-module__yZHw7W__main-header-container",
  "subTitle": "VideoTourSection-module-scss-module__yZHw7W__subTitle",
  "txt-12-bold": "VideoTourSection-module-scss-module__yZHw7W__txt-12-bold",
  "txt-14-bold": "VideoTourSection-module-scss-module__yZHw7W__txt-14-bold",
  "txt-14-bold-caps": "VideoTourSection-module-scss-module__yZHw7W__txt-14-bold-caps",
  "txt-14-med": "VideoTourSection-module-scss-module__yZHw7W__txt-14-med",
  "txt-16-bold": "VideoTourSection-module-scss-module__yZHw7W__txt-16-bold",
  "txt-16-med": "VideoTourSection-module-scss-module__yZHw7W__txt-16-med",
  "txt-18-bold": "VideoTourSection-module-scss-module__yZHw7W__txt-18-bold",
  "txt-18-medium": "VideoTourSection-module-scss-module__yZHw7W__txt-18-medium",
  "txt-18-medium-24": "VideoTourSection-module-scss-module__yZHw7W__txt-18-medium-24",
  "txt-24-semi": "VideoTourSection-module-scss-module__yZHw7W__txt-24-semi",
  "videoTour": "VideoTourSection-module-scss-module__yZHw7W__videoTour",
});
